import axios from "../../axiosMiddleware";
import { api } from "../../apiendpoints/index";

export const GetDeviceData = async (data) => {
  return axios.post(`${api.ASAI.GET_DEVICE_DATA}`, data);
};

export const ImportDeviceData = async (file) => {
  const formData = new FormData();

  formData.append("file", file);

  return axios.post(`${api.ASAI.IMPORT_DEVICE_DATA}`, formData);
};

export const GetOrganizations = () => {
  return axios.get(api.ASAI.GET_ORGANIZATIONS);
};

export const GetTenHoursShiftDetails = async (data) => {
  return axios.post(api.ASAI.GET_TEN_HOURS_SHIFT_DETAILS, data);
};

export const GetEightHoursShiftDetails = async (data) => {
  return axios.post(api.ASAI.GET_EIGHT_HOURS_SHIFT_DETAILS, data);
};

export const ImportEightHoursShift = async (data) => {
  return axios.post(api.ASAI.IMPORT_EIGHT_HOURS_SHIFT, data);
};

export const GetTenHoursReport = async (data) => {
  return axios.post(api.ASAI.GET_TEN_HOURS_REPORT, data);
};

export const GetEightHoursReport = async (data) => {
  return axios.post(api.ASAI.GET_EIGHT_HOURS_REPORT, data);
};

export const GetEightHoursOvertimeReport = async (data) => {
  return axios.post(api.ASAI.GET_EIGHT_HOURS_OVERTIME_REPORT, data);
};

export const GetEmployeeMonthlyAttendance = async (data) => {
  return axios.post(api.ASAI.GET_EMPLOYEE_MONTHLY_ATTENDANCE, data);
};

export const ImportTenHoursShift = async (data) => {
  return axios.post(api.ASAI.IMPORT_TEN_HOURS_SHIFT, data);
};

export const GetMonthlyAttendanceReport = async (
  data,
  signal?: AbortSignal,
) => {
  return axios.post(api.ASAI.GET_MONTHLY_ATTENDANCE_REPORT, data, { signal });
};
export const GetEmployeeAttendanceAndLeaveDetails = async (data) => {
  return axios.get(api.ASAI.GET_EMPLOYEE_ATTENDANCE_AND_LEAVE_DETAILS, { params: data });
};

export const GetASAISubDepartments = async (departmentId) => {
  return axios.get(api.ASAI.GetASAISubDepartments, {
    params: departmentId
      ? {
          departmentId,
        }
      : undefined,
  });
};

export const GetDepartmentShifts = async (shiftHours = 10, departmentId) => {
  return axios.get(api.ASAI.GetDepartmentShifts, {
    params: {
      shiftHours,
      ...(departmentId
        ? {
            departmentId,
          }
        : {}),
    },
  });
};

export const ImportShiftRecords = async (data) => {
  return axios.post(api.ASAI.IMPORT_SHIFT_RECORDS, {
    data,
  });
};

export const GetCurrentShiftImportRecords = async (data) => {
  return axios.post(api.ASAI.GET_CURRENT_SHIFT_IMPORT_RECORDS, {
    data,
  });
};

export const SaveShiftRosterChanges = async (data) => {
  return axios.post(api.ASAI.SAVE_SHIFT_ROSTER_CHANGES, { data });
};

export const GetMonthlyPunchDetails = async (data) => {
  return axios.post(api.ASAI.GET_MONTHLY_PUNCH_DETAILS, data);
};

export const SaveEmployeeShiftOverride = async (data) => {
  return axios.post(api.ASAI.SAVE_EMPLOYEE_SHIFT_OVERRIDE, { data });
};

export const GetEmployeeShiftOverrideHistory = async (data) => {
  return axios.post(api.ASAI.GET_EMPLOYEE_SHIFT_OVERRIDE_HISTORY, { data });
};
